import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';
import { debounce } from 'ts-debounce';
import { TextFieldTheme, Checkbox as TPACheckbox, TextField as TPATextField } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '../../contexts/translation-context';
import { OTHER_ID, getIsOtherOptionSelected, getOptionsNames, getOtherLabel, getOtherValue } from '../../ui/checkbox-group-field/checkbox-group-field-utils';
import styles from '../../ui/checkbox-group-field/checkbox-group-field-wut.module.scss';
import { classes } from '../../ui/checkbox-group-field/checkbox-group-field-wut.st.css';
export const OtherOptionWUT = _ref => {
  let {
    label,
    options,
    addOther,
    addOtherLabel,
    addOtherPlaceholder,
    minLength,
    maxLength,
    value = null,
    onChange,
    disabled,
    hasError
  } = _ref;
  const _value = useMemo(() => value || [], [value]);
  const optionsNames = useMemo(() => getOptionsNames(options), [options]);
  const isOtherOptionSelected = getIsOtherOptionSelected(_value, optionsNames);
  const [otherSelected, setOtherSelected] = useState(isOtherOptionSelected);
  const [otherValue, setOtherValue] = useState(isOtherOptionSelected ? getOtherValue(_value, addOtherLabel) : '');
  const {
    t
  } = useTranslation();
  const otherLabel = getOtherLabel(addOtherLabel, t);
  const otherOptionCheckboxChange = event => {
    setOtherSelected(event.checked);
    setOtherValue('');
    handleOtherChange(event.checked ? `${otherLabel}` : '');
  };
  const handleOtherChange = useCallback(newValue => {
    const removedOther = _value.filter(val => optionsNames.includes(val));
    const _newValue = newValue.length > 0 ? [...removedOther, newValue] : removedOther;
    onChange(_newValue);
  }, [onChange, optionsNames, _value]);
  const handleOtherInputChange = event => {
    const input = event.target.value;
    const _otherValue = input ? `${addOtherLabel}: ${input}` : otherLabel;
    setOtherValue(input);
    setOtherSelected(true);
    debouncedHandleOtherChange(_otherValue);
  };
  const debouncedHandleOtherChange = useMemo(() => {
    return debounce(handleOtherChange, 500);
  }, [handleOtherChange]);
  if (!addOther) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.otherContainer
  }, /*#__PURE__*/React.createElement(TPACheckbox, {
    key: `checkbox-${OTHER_ID}`,
    checked: otherSelected,
    onChange: otherOptionCheckboxChange,
    label: otherLabel,
    name: label,
    disabled: disabled,
    error: hasError,
    className: classNames(classes.checkbox, styles.checkbox, {
      [styles.checkboxError]: hasError
    })
  }), otherSelected && /*#__PURE__*/React.createElement(TPATextField, {
    className: classNames(classes.otherInput, classes.theme),
    value: otherValue,
    placeholder: addOtherPlaceholder,
    minLength: minLength,
    maxLength: maxLength,
    onChange: handleOtherInputChange,
    disabled: disabled,
    error: hasError,
    theme: TextFieldTheme.Box,
    showCharCount: Boolean(maxLength),
    "aria-label": otherLabel
  }));
};
//# sourceMappingURL=other-option-wut.js.map